import React, { useState, useEffect, useRef } from "react";
import prendasModule from "../styles/Prendas.module.css";
import { useDataContext } from "../contexts/AuthContext";
import {
  getGuide,
  getSketchByOrderItemId,
  approveSketch,
  getAditionalDataOfItem,
  completeSizes, 
  getAllCategories,
  obtainGuideStatus,
  getPrendasTutor,
  getSizes,
  getMasterTemplateForOrderItem,
} from "../services/api";
import BocetoModal from "./BocetoModal";
import AprobarModal from "./AprobarModal";
import fantasma from "../images/fantasmaOpinion.png";
import logoPng from "../images/Frame.png";
import archivo from "../images/Capa_1archivo.png";
import MediTuLittleModal from "./MediTuLittleModal.jsx";
import ModalTutorial1 from "./modalTutorial1";
import ModalTutorial2 from "./ModalTutorial2";
import ModalTutorial3 from "./ModalTutorial3";
import ModalTutorial4 from "./ModalTutorial4";
import ModalTutorial5 from "./ModalTutorial5";
import ModalTutorial6 from "./ModalTutorial6";
import ModalTutorial7 from "./ModalTutorial7";
import ModalTutorialIntermediate from "./ModaltutorialIntermediate";
import GuiaRemera1 from "./GuiaRemera1";
import GuiaRemera2 from "./GuiaRemera2";
import GuiaRemera3 from "./GuiaRemera3";
import GuiaRemera4 from "./GuiaRemera4";
import GuiaRemera5 from "./GuiaRemera5";
import GuiaRemera6 from "./GuiaRemera6";
import GuiaRemera7 from "./GuiaRemera7";
import GuiaRemeraIntermediate from "./GuiaRemeraIntemediate";
import CargarTalle from "./CargarTalle.jsx";
import Swal from "sweetalert2";
import SizeTable from "./SizeTable";
import Arrow from "../images/flecha-magenta.png";
import CargarGuia from "../components/CargarGuia.jsx";
import PrendasBocetos from "./PrendasBocetos.jsx";
import { resolveFileUrl } from "../utils/media";
import { useNavigate } from "react-router-dom";

// Categoría → qué tutorial de guía abrir. Regex para soportar los nombres de V3
// ("Buzos"/"Remeras") y los de V4 ("Buzo/Campera"/"Chomba/Remera").
const isBuzoCat = (c) => /buzo|campera|anorak/i.test(String(c || ""));
const isRemeraCat = (c) => /chomba|remera/i.test(String(c || ""));

export default function Prendas() {
  // Go-live: el diseñador queda OCULTO por default (flag de env). Cuando está apagado,
  // se muestra el flujo de descargar/completar la guía (legacy). Para prenderlo:
  // REACT_APP_DESIGNER_ENABLED=true
  const SHOW_DESIGNER = String(process.env.REACT_APP_DESIGNER_ENABLED || "").toLowerCase() === "true";
  const SHOW_LEGACY_GUIDE_UPLOAD = !SHOW_DESIGNER;
  const { contextData, checkCustomerAlive } = useDataContext();
  const navigate = useNavigate();
  const [guiaDesplegada, setGuiaDesplegada] = useState(false);
  const [bocetoDesplegado, setBocetoDesplegado] = useState(false);
  const [talleDesplegado, setTalleDesplegado] = useState(false);
  const [prendaSeleccionada, setPrendaSeleccionada] = useState(null);
  const [prendas, setPrendas] = useState([]);
  const [orderItemId, setOrderItemId] = useState("");
  const [sketch, setSketch] = useState({});
  const [downloadUrl, setDownloadUrl] = useState("");
  const [paxes, setPaxes] = useState("");
  const [requirementExpiration, setRequirementExpiration] = useState("");
  const [showModalCargarGuia, setShowModalCargarGuia] = useState(false);
  const [estadoGuia, setEstadoGuia] = useState("inexistente");
  const [completedMessage, setCompleteMessage] = useState("");
  const [approvedMessage, setApprovedMessage] = useState("");
  const [seleccionAutomatica, setSeleccionAutomatica] = useState(false);
  const [sizes, setSizes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentModal, setCurrentModal] = useState(0);
  const [currentModalRemeras, setCurrentModalRemeras] = useState(0);
  const [showModalA, setShowModalA] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [botonHabilitado, setBotonHabilitado] = useState(true);
  const [showModalMediTuLittle, setShowModalMediTuLittle] = useState(false);
  const [showModalCargarTalles, setShowModalCargarTalles] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const molding_itemCategory = useRef({ moldingId: 0, orderItemCategoryId: 0 });

  const toggleGuiaDesplegable = () => {
    setGuiaDesplegada(!guiaDesplegada);
  };
  const toggleBocetoDesplegado = () => {
    setBocetoDesplegado(!bocetoDesplegado);
  };
  const toggleTalleDesplegado = () => {
    setTalleDesplegado(!talleDesplegado);
  };

  useEffect(() => {
    if (!contextData || !contextData.customer || !contextData.customer.id) {
      return;
    }

    const fetchData = async () => {
      try {
        const isAlive = await checkCustomerAlive(contextData.customer.id);
        if (!isAlive) {
          Swal.fire({
            icon: "warning",
            iconColor: "#d54ab7",
            confirmButtonColor: "#0071ce",
            title: "Atencion",
            text: "Tu cuenta ha sido desactivada. Por favor, contacta con tu representante para más información.",
          }).then(() => {
            navigate("/");
          });
          return;
        }
        let data;
        if (
          contextData.customer.customer_type === 3 ||
          contextData.customer.customer_type === 2
        ) {
          data = await getPrendasTutor(
            contextData.customer.lead_id,
            contextData.customer.order_id,
            contextData.customer.access_code || contextData.customer.username
          );
        } else {
          data = await getAllCategories(contextData.customer.id, contextData.customer.order_id);
        }

        const prendasConPath = data.map((prenda) => {
          let path;
          let alternativePath;
          switch (prenda.category_name) {
            case "Buzos":
              path = `buzo.png`;
              alternativePath = `buzo1.png`;
              break;
            case "Chombas":
              path = `chomba.png`;
              alternativePath = `chomba1.png`;
              break;
            case "Remeras":
              path = `remeras.png`;
              alternativePath = `remeras1.png`;
              break;
            case "Joggings":
              path = `joggings.png`;
              alternativePath = `joggings1.png`;
              break;
            case "Mochilas":
              path = `mochilas.png`;
              alternativePath = `mochilas1.png`;
              break;
            case "Camperas":
              path = `camperas.png`;
              alternativePath = `camperas1.png`;
              break;
            case "Otros":
              switch (prenda.product_name) {
                case "Bandera":
                  path = `bandera.png`;
                  alternativePath = `bandera1.png`;
                  break;
                default:
                  path = `otros.png`;
                  alternativePath = `otros1.png`;
              }
              break;
            default:
              path = "bandera.png";
              alternativePath = "bandera1.png";
          }
          return { ...prenda, path, alternativePath };
        });
        setPrendas(prendasConPath);
        setLoading(false);

      } catch (error) {
        console.error("Error fetching prendas:", error);
      }
    };

    fetchData();
  }, [contextData]);

  useEffect(() => {
    if (!prendaSeleccionada) {
      return;
    }
    const fetchSketch = async () => {
      try {
        const data = await getSketchByOrderItemId(
          prendaSeleccionada.order_item_id
        );
        setSketch(data);
        setDownloadUrl(resolveFileUrl(data?.filename || ""));
      } catch (error) {
        setSketch({});
        setDownloadUrl("");
        console.error("Error fetching sketch:", error);
      }
    };

    if (prendaSeleccionada) {
      fetchSketch();
    }
  }, [prendaSeleccionada]);

  useEffect(() => {
    if (!prendaSeleccionada) {
      return;
    }
    const fetchAditionalDataOfItem = async () => {
      try {
        const data = await getAditionalDataOfItem(
          prendaSeleccionada.order_item_id
        );
        setPaxes(data.totalPaxes);
        setRequirementExpiration(data.requirementExpiration);
        molding_itemCategory.current.moldingId = data.moldingId;
        molding_itemCategory.current.orderItemCategoryId = data.orderItemCategoryId;

        if (data.completedMessage) {
          setCompleteMessage(data.completedMessage);
          setBotonHabilitado(false);
        } else {
          setCompleteMessage("");
          setBotonHabilitado(true);
        }

        if (data.approvedMessage) {
          setApprovedMessage(data.approvedMessage);
          setBotonHabilitado(false);
        } else {
          setApprovedMessage("");
          // setBotonHabilitado(true);
        }
      } catch (error) {
        console.error("Error fetching aditional data of item:", error);
      }
    };

    if (prendaSeleccionada) {
      fetchAditionalDataOfItem();
    }
  }, [prendaSeleccionada]);

  const handleCloseAllModals = () => {
    setCurrentModal(null);
  };

  const handleNext = () => {
    if (currentModal === 6 && window.innerWidth >= 1024) {
      setCurrentModal(6.5);
    } else if (currentModal === 6.5) {
      setCurrentModal(7);
    } else {
      setCurrentModal((prevModal) => prevModal + 1);
    }
  };

  const handleBack = () => {
    if (currentModal === 6.5) {
      setCurrentModal(6); // Retroceder al modal 6 (previo al intermedio)
    } else if (currentModal === 7 && window.innerWidth >= 1024) {
      setCurrentModal(6.5);
    } else {
      setCurrentModal(currentModal - 1);
    }
  };

  const toggleModaltutorial = () => {
    setCurrentModal(1);
  };

  const toggleModalRemeras = () => {
    setCurrentModalRemeras(1);
  };
  const handleCloseAllModalsRemera = () => {
    setCurrentModalRemeras(null);
  };
  const handleNextRemera = () => {
    if (currentModalRemeras === 6 && window.innerWidth >= 1024) {
      setCurrentModalRemeras(6.5);
    } else if (currentModalRemeras === 6.5) {
      setCurrentModalRemeras(7);
    } else {
      setCurrentModalRemeras((prevModal) => prevModal + 1);
    }
  };
  const handleBackRemera = () => {
    if (currentModalRemeras === 6.5) {
      setCurrentModalRemeras(6); // Retroceder al modal 6 (previo al intermedio)
    } else if (currentModalRemeras === 7 && window.innerWidth >= 1024) {
      setCurrentModalRemeras(6.5);
    } else {
      setCurrentModalRemeras(currentModalRemeras - 1);
    }
  };

  const handleClickPrenda = async (prenda) => {
    try {
      // Obtén la guía para la nueva prenda
      const data = await getGuide(prenda.order_item_id);
      setOrderItemId(prenda.order_item_id);

      // Actualiza la guía de la prenda seleccionada
      const prendaActualizada = { ...prenda, guide_url: data.guide_url };

      // Actualiza el estado de la prenda seleccionada y la guía
      setPrendaSeleccionada(prendaActualizada);
      setGuiaDesplegada(true);

      // Restaura el estado de 'pressed' de las demás prendas
      const updatedPrendas = prendas.map((item) =>
        item === prenda
          ? { ...item, pressed: true }
          : { ...item, pressed: false }
      );
      setPrendas(updatedPrendas);
    } catch (error) {
      console.error("Error fetching guide:", error);
    }
  };

  const toggleModalA = async (id) => {
    try {
      const data = await approveSketch(
        orderItemId,
        contextData.customer.id,
        id
      );
      if (data.status === 201) {
        setShowModalA(!showModalA);
        setSketch(data.sketch);
      } else {
        console.log("Error al aprobar el boceto", data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const closeModalA = () => {
    setShowModalA(!showModalA);
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };


  const toggleModalMediTuLittle = () => {
    setShowModalMediTuLittle(!showModalMediTuLittle);
  };
  
  const toggleCargarTalles = () =>
    setShowModalCargarTalles(!showModalCargarTalles);
  
  const toggleOpen = () => {
    if (prendaSeleccionada === null) {
      Swal.fire({
        icon: "warning",
        iconColor: "#d54ab7",
        confirmButtonColor: "#0071ce",
        title: "Atención",
        text: "Debes seleccionar una prenda.",
      });
    } else {
      setIsOpen(!isOpen);
    }
  };

  const handleModalCargarGuia = () => {
    setShowModalCargarGuia(true);
  };

  const cerrarModalCargarGuia = () => {
    setShowModalCargarGuia(false);
  };

  useEffect(() => {
    if (!orderItemId) {
      return;
    }
    obtenerEstadoGuia(orderItemId);
  }, [orderItemId]);

  const obtenerEstadoGuia = async (order_item_id) => {
    try {
      const data = await obtainGuideStatus(order_item_id);
      if (data.rejected === true && data.approved === false) {
        setEstadoGuia("rechazada");
      } else if (data.rejected === false && data.approved === true) {
        setEstadoGuia("aprobada");
      } else if (data.rejected === false && data.approved === false) {
        setEstadoGuia("pendiente");
      } else if (data.exists === false) {
        setEstadoGuia("inexistente");
      }
    } catch (error) {
      console.error("Error fetching aditional data of guide:", error);
    }
  };

  const handleAlertconfirm = () => {
    if (!prendaSeleccionada) {
      Swal.fire({
        icon: "warning",
        iconColor: "#d54ab7",
        confirmButtonColor: "#0071ce",
        title: "Atención",
        text: "Por favor, selecciona una prenda antes de continuar.",
      });
      return;
    }
    let mensaje;
    if (sizes.length === paxes) {
      mensaje = `¿Está seguro que desea confirmar ${sizes.length} talles para ${prendaSeleccionada.product_name}?`;
    } else {
      mensaje = `¿Desea confirmar ${sizes.length} de ${paxes} ${prendaSeleccionada.product_name} encargados/as originalmente?`;
    }

    Swal.fire({
      title: mensaje,
      showCancelButton: true,
      confirmButtonText: "Sí",
      confirmButtonColor: "#0071ce",
      cancelButtonText: "No",
      cancelButtonColor: "#d54ab7",
    }).then(async (result) => {
      if (result.isConfirmed) {
        console.log("Usuario confirmó los talles.");
        setBotonHabilitado(false);
        const datos = {
          order_item_id: orderItemId,
          customer_id: contextData.customer.id,
        };
        await completeSizes(datos);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        console.log("Usuario canceló la confirmación de talles.");
      }
    });
  };

  useEffect(() => {
    if (prendas.length === 1 && !seleccionAutomatica) {
      handleClickPrenda(prendas[0]);
      setSeleccionAutomatica(true);
    }
  }, [prendas, seleccionAutomatica]);

  useEffect(() => {
    fetchData2();
  }, [orderItemId]);

  const fetchData2 = async () => {
    try {
      if (!orderItemId) {
        console.log("No se ha seleccionado ningún ítem.");
        return;
      }

      const data = await getSizes(orderItemId);
      setSizes(data);
    } catch (error) {
      console.error("Error al obtener los datos:", error);
    }
  };

  const getOrderType = (prenda) => {
    switch (prenda.order_type) {
      case 2:
        return 'Extra';
      case 3:
        return 'Arreglo';
      case 4:
        return 'Faltante';
      default:
        return 'Pedido';
    }
  };

  // Nombre a mostrar en la card: el NOMBRE COMERCIAL (nice_name, sin el prefijo "NN:" del
  // catálogo) + el alias del ítem si lo tiene. Fallback al nombre del master.
  const nombreArticulo = (prenda) => {
    const base = String(prenda.nice_name || prenda.product_name || "").replace(/^\s*\d+\s*[:.\-]\s*/, "").trim()
      || prenda.product_name || "Artículo";
    const alias = String(prenda.alias || "").trim();
    return alias ? `${base} ${alias}` : base;
  };

  const handleOpenDesigner = async () => {
    if (!prendaSeleccionada) {
      Swal.fire({
        icon: "warning",
        iconColor: "#d54ab7",
        confirmButtonColor: "#0071ce",
        title: "Atención",
        text: "Por favor, seleccioná una prenda antes de abrir el diseñador.",
      });
      return;
    }

    if (estadoGuia === "pendiente") {
      Swal.fire({
        icon: "info",
        iconColor: "#0071ce",
        confirmButtonColor: "#0071ce",
        title: "Guía pendiente de revisión",
        html: "Esta prenda ya tiene una guía cargada y está pendiente de revisión de <strong>Little Blue</strong>.",
      });
      return;
    }

    try {
      const guardResponse = await getMasterTemplateForOrderItem(prendaSeleccionada.order_item_id, 0);
      const canCreate = guardResponse?.can_create !== undefined
        ? !!guardResponse.can_create
        : !guardResponse?.exists;

      if (!canCreate) {
        Swal.fire({
          icon: "info",
          iconColor: "#0071ce",
          confirmButtonColor: "#0071ce",
          title: "Diseño en revisión",
          html: "Ya hay una guía cargada para esta prenda y está pendiente de revisión de <strong>Little Blue</strong>.",
        });
        return;
      }
    } catch (error) {
      Swal.fire({
        icon: "warning",
        iconColor: "#d54ab7",
        confirmButtonColor: "#0071ce",
        title: "No se pudo validar",
        text: "No pudimos verificar el estado de la guía. Intentá nuevamente en unos segundos.",
      });
      return;
    }

    navigate(`/mcb/prendas/designer/${prendaSeleccionada.order_item_id}`);
  };

  // Usuario normal (read-only): solo ve el boceto vigente de cada prenda + su estado.
  // La guía/diseño y los talles los manejan tutor/delegado y sus propias secciones.
  if (contextData.customer.customer_type === 1) {
    return <PrendasBocetos />;
  }

  return (
    <>
      {loading ? (
        <div className="contcargando">
          <img src={logoPng} alt="littleBlueLogo" className="imgcargando" />
          <h2 className="text-muted">CARGANDO...</h2>
          <div className="loader"></div>
        </div>
      ) : (
        <div className={`container ${prendasModule.container1}`}>
          {prendas.length > 1 && (
            <h5 className={prendasModule.subtitle}>
              Seleccione <span style={{ color: "#d54ab7" }}>una </span> prenda
            </h5>
          )}

          <div className={`row ${prendasModule.containerbotonprendas}`}>
            {prendas.map((prenda) => {
              const fallbackImg = require(`../images/imagenesPrendas/${
                prenda.pressed ? prenda.alternativePath : prenda.path
              }`);
              const displayName = nombreArticulo(prenda);
              return (
              <div
                key={prenda.order_item_id}
                className={`col ${prendasModule.prendaContainer}`}
              >
                <button
                  className={`${prendasModule.prendaBoton} ${
                    prendaSeleccionada?.order_item_id === prenda.order_item_id
                      ? prendasModule.seleccionado
                      : ""
                  } ${prenda.pressed ? prendasModule.agrandarBoton : ""}`}
                  onClick={() => handleClickPrenda(prenda)}
                >
                  {/* Miniatura del MODELO seleccionado (base, sin pintar). El PNG del master es un
                      "2-up" (gris + azul); mostramos solo la de la izquierda (gris), igual que el
                      catálogo "Cambiar modelo". Si el master no tiene imagen, cae a la ilustración
                      genérica de la categoría (una sola prenda → sin recorte). */}
                  {prenda.model_img ? (
                    <span className={prendasModule.modelThumb}>
                      <img
                        src={resolveFileUrl(prenda.model_img)}
                        onError={(e) => {
                          const img = e.currentTarget;
                          img.onerror = null;
                          img.src = fallbackImg;
                          img.style.width = "100%";
                          img.style.objectFit = "contain";
                          img.style.objectPosition = "center";
                        }}
                        alt={displayName}
                        className={prendasModule.modelThumbImg}
                      />
                    </span>
                  ) : (
                    <img
                      src={fallbackImg}
                      alt={displayName}
                      className={prendasModule.prendas}
                    />
                  )}

                  <p className={prendasModule.nombrePrenda}>
                    {displayName}
                  </p>
                </button>
              </div>
              );
            })}
          </div>

          {/* guia */}
          {contextData.customer.customer_type !== 1 && (
            <div className={`mt-3 ${prendasModule.guiaContainer}`}>
              <div>
                <button
                  className={`btn ${prendasModule.guiaBoton}`}
                  onClick={toggleGuiaDesplegable}
                >
                  <span className={prendasModule.sectionHeaderMain}>
                    <span className={prendasModule.sectionTitleIconWrap}>
                      <i className={`bi bi-file-earmark-text ${prendasModule.sectionTitleIconMain}`} aria-hidden="true"></i>
                      <i className={`bi bi-pencil-fill ${prendasModule.sectionTitleIconAccent}`} aria-hidden="true"></i>
                    </span>
                    <span className={prendasModule.sectionTitleTextWrap}>
                      <span className={prendasModule.sectionTitleText}>Guía de Diseño</span>
                      <span className={prendasModule.sectionTitleUnderline} aria-hidden="true"></span>
                    </span>
                  </span>
                  {guiaDesplegada ? (
                    <i className={`bi bi-caret-up-fill ${prendasModule.guiaToggleIcon}`}></i>
                  ) : (
                    <i className={`bi bi-caret-down-fill ${prendasModule.guiaToggleIcon}`}></i>
                  )}
                </button>
              </div>

              <div className={`mt-2 collapse ${guiaDesplegada ? "show" : ""}`}>
                <div className={prendasModule.containerprincipalguia}>
                  {SHOW_LEGACY_GUIDE_UPLOAD && (
                    <>
                      <div>
                        <h1 className={prendasModule.descargaGuia}>
                          DESCARGÁ LA GUÍA
                        </h1>
                      </div>
                      <div className={prendasModule.mensajeContainer}>
                        <p className={prendasModule.mensaje}>
                          Completá la GUÍA, lo más detallada posible, con tu diseño
                          para que podamos realizar el boceto
                        </p>
                      </div>
                      {prendaSeleccionada?.guide_url ? (
                        <a
                          className={prendasModule.botoncompletar}
                          href={prendaSeleccionada.guide_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8, textDecoration: "none", marginBottom: 10 }}
                        >
                          <i className="bi bi-download" aria-hidden="true"></i>
                          <span>Descargar guía</span>
                        </a>
                      ) : (
                        <button
                          className={prendasModule.botoncompletar}
                          style={{ marginBottom: 10 }}
                          onClick={() =>
                            Swal.fire({
                              icon: "info",
                              iconColor: "#0071ce",
                              confirmButtonColor: "#0071ce",
                              title: "Seleccioná una prenda",
                              text: "Tocá una prenda arriba para descargar su guía.",
                            })
                          }
                        >
                          <i className="bi bi-download" aria-hidden="true"></i>
                          <span>Descargar guía</span>
                        </button>
                      )}
                      <button
                        className={prendasModule.botoncompletar}
                        onClick={() => {
                          if (!prendaSeleccionada) {
                            Swal.fire({
                              icon: "warning",
                              iconColor: "#d54ab7",
                              confirmButtonColor: "#0071ce",
                              title: "Atención",
                              text: "Por favor, selecciona una prenda antes de continuar.",
                            });
                          } else if (isBuzoCat(prendaSeleccionada.category_name)) {
                            toggleModaltutorial();
                          } else if (isRemeraCat(prendaSeleccionada.category_name)) {
                            toggleModalRemeras();
                          } else {
                            Swal.fire({
                              icon: "info",
                              iconColor: "#d54ab7",
                              confirmButtonColor: "#0071ce",
                              title: "Información",
                              text: `No hay tutorial disponible para ${prendaSeleccionada.category_name}.`,
                            });
                          }
                        }}
                      >
                        ¿Cómo la completo?
                      </button>
                    </>
                  )}

                  {prendaSeleccionada &&
                    isBuzoCat(prendaSeleccionada.category_name) && (
                      <>
                        {currentModal === 1 && (
                          <ModalTutorial1
                            onNext={handleNext}
                            onBack={handleBack}
                            onClose={handleCloseAllModals}
                          />
                        )}
                        {currentModal === 2 && (
                          <ModalTutorial2
                            onNext={handleNext}
                            onBack={handleBack}
                            onClose={handleCloseAllModals}
                          />
                        )}
                        {currentModal === 3 && (
                          <ModalTutorial3
                            onNext={handleNext}
                            onBack={handleBack}
                            onClose={handleCloseAllModals}
                          />
                        )}
                        {currentModal === 4 && (
                          <ModalTutorial4
                            onNext={handleNext}
                            onBack={handleBack}
                            onClose={handleCloseAllModals}
                          />
                        )}
                        {currentModal === 5 && (
                          <ModalTutorial5
                            onNext={handleNext}
                            onBack={handleBack}
                            onClose={handleCloseAllModals}
                          />
                        )}
                        {currentModal === 6 && (
                          <ModalTutorial6
                            onNext={handleNext}
                            onBack={handleBack}
                            onClose={handleCloseAllModals}
                          />
                        )}
                        {currentModal === 6.5 && (
                          <ModalTutorialIntermediate
                            onNext={handleNext}
                            onBack={handleBack}
                            onClose={handleCloseAllModals}
                          />
                        )}

                        {currentModal === 7 && (
                          <ModalTutorial7
                            onNext={handleNext}
                            onBack={handleBack}
                            onClose={handleCloseAllModals}
                          />
                        )}
                      </>
                    )}
                  {prendaSeleccionada &&
                    isRemeraCat(prendaSeleccionada.category_name) && (
                      <>
                        {currentModalRemeras === 1 && (
                          <GuiaRemera1
                            onNext={handleNextRemera}
                            onClose={handleCloseAllModalsRemera}
                          />
                        )}
                        {currentModalRemeras === 2 && (
                          <GuiaRemera2
                            onNext={handleNextRemera}
                            onBack={handleBackRemera}
                            onClose={handleCloseAllModalsRemera}
                          />
                        )}
                        {currentModalRemeras === 3 && (
                          <GuiaRemera3
                            onNext={handleNextRemera}
                            onBack={handleBackRemera}
                            onClose={handleCloseAllModalsRemera}
                          />
                        )}
                        {currentModalRemeras === 4 && (
                          <GuiaRemera4
                            onNext={handleNextRemera}
                            onBack={handleBackRemera}
                            onClose={handleCloseAllModalsRemera}
                          />
                        )}
                        {currentModalRemeras === 5 && (
                          <GuiaRemera5
                            onNext={handleNextRemera}
                            onBack={handleBackRemera}
                            onClose={handleCloseAllModalsRemera}
                          />
                        )}
                        {currentModalRemeras === 6 && (
                          <GuiaRemera6
                            onNext={handleNextRemera}
                            onBack={handleBackRemera}
                            onClose={handleCloseAllModalsRemera}
                          />
                        )}
                        {currentModalRemeras === 6.5 && (
                          <GuiaRemeraIntermediate
                            onNext={handleNextRemera}
                            onBack={handleBackRemera}
                            onClose={handleCloseAllModalsRemera}
                          />
                        )}
                        {currentModalRemeras === 7 && (
                          <GuiaRemera7
                            onNext={handleNextRemera}
                            onBack={handleBackRemera}
                            onClose={handleCloseAllModalsRemera}
                          />
                        )}
                      </>
                    )}
                  {SHOW_DESIGNER && (<>
                  <div>
                    <h2 className={prendasModule.designerBlockTitle}>
                      Tu prenda, a tu manera
                    </h2>
                    <p className={prendasModule.designerBlockText}>
                      Elegí los colores y sumale escudos, logos, nombres, números o dibujos. ¡Hacela como vos querés!
                    </p>
                    <p className={prendasModule.designerBlockText}>
                      Tu diseño nos va a servir de guía: nuestro equipo de diseño va a preparar el boceto final y te lo vamos a mostrar para que lo apruebes antes de fabricar tu prenda.
                    </p>
                  </div>
                  <div style={{ marginTop: 12 }}>
                    <button
                      className={prendasModule.botoncompletar}
                      onClick={handleOpenDesigner}
                    >
                      <i className={`bi bi-pencil-square ${prendasModule.botonCompletarIcon}`} aria-hidden="true"></i>
                      <span>Empezar mi diseño</span>
                    </button>
                    {estadoGuia === "pendiente" && (
                      <p className={prendasModule.mensajeAdvertencia} style={{ marginTop: 10 }}>
                        <i className={`bi bi-exclamation-circle ${prendasModule.mensajeAdvertenciaIcon}`} aria-hidden="true"></i>
                        <span>
                          Guía ya cargada, pendiente de revisión de <strong>Little Blue</strong>.
                        </span>
                      </p>
                    )}
                  </div>
                  </>)}
                  {SHOW_LEGACY_GUIDE_UPLOAD && (
                    <>
                      <div>
                        <h2 className={prendasModule.descargaGuia}>
                          ¿YA COMPLETASTE LA GUÍA?
                        </h2>
                      </div>
                      <div className={prendasModule.mensajeContainer}>
                        <p className={prendasModule.mensaje}>
                          Buenísimo! Podés subirla acá junto a cualquier referencia
                          que nos sirva para entender tu diseño: escudos, logos,
                          imágenes, dibujos, etc.
                        </p>
                        {prendaSeleccionada !== null ? (
                          <div className={prendasModule.containercargarguia}>
                            <img
                              src={archivo}
                              alt="Referencia de diseño"
                              className={prendasModule.imagenarchivo}
                            />
                            {estadoGuia === "aprobada" && (
                              <button
                                className={prendasModule.cargarBoton}
                                onClick={handleModalCargarGuia}
                              >
                                Guía aprobada <i className="bi bi-check-circle"></i>
                              </button>
                            )}
                            {estadoGuia === "rechazada" && (
                              <button
                                className={prendasModule.cargarBoton}
                                onClick={handleModalCargarGuia}
                              >
                                Guía rechazada <i className="bi bi-dash-circle"></i>
                              </button>
                            )}
                            {estadoGuia === "pendiente" && (
                              <button
                                className={prendasModule.cargarBoton}
                                onClick={handleModalCargarGuia}
                              >
                                Guia pendiente <i className="bi bi-clock"></i>
                              </button>
                            )}
                            {estadoGuia === "inexistente" && (
                              <button
                                className={prendasModule.cargarBoton}
                                onClick={handleModalCargarGuia}
                              >
                                Cargá tu guía
                              </button>
                            )}
                          </div>
                        ) : (
                          <div className={prendasModule.containercargarguia}>
                            <img
                              src={archivo}
                              alt="Referencia de diseño"
                              className={prendasModule.imagenarchivo}
                            />
                            <button className={prendasModule.cargarBoton} disabled>
                              Seleccione una prenda
                            </button>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}


          <section className={`mt-3 ${prendasModule.guiaContainer}`}>
            <button
              className={`btn ${prendasModule.guiaBoton}`}
              onClick={() => {
                if (!prendaSeleccionada) {
                  Swal.fire({
                    icon: "warning",
                    iconColor: "#d54ab7",
                    confirmButtonColor: "#0071ce",
                    title: "Atención",
                    text: "Por favor, selecciona una prenda antes de continuar.",
                  });
                } else {
                  toggleBocetoDesplegado();
                }
              }}
            >
              <span className={prendasModule.sectionHeaderMain}>
                <span className={prendasModule.sectionTitleIconWrap}>
                  <svg
                    viewBox="0 0 24 24"
                    className={prendasModule.sectionTitleSvgIcon}
                    aria-hidden="true"
                  >
                    <path d="M9 4l3 2 3-2 3 2 2 5-3 1v8a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-8l-3-1 2-5 3-2z" />
                  </svg>
                </span>
                <span className={prendasModule.sectionTitleTextWrap}>
                  <span className={prendasModule.sectionTitleText}>Ver Boceto</span>
                  <span className={prendasModule.sectionTitleUnderline} aria-hidden="true"></span>
                </span>
              </span>
              {bocetoDesplegado ? (
                <i className={`bi bi-caret-up-fill ${prendasModule.guiaToggleIcon}`}></i>
              ) : (
                <i className={`bi bi-caret-down-fill ${prendasModule.guiaToggleIcon}`}></i>
              )}
            </button>
            <div className={`mt-2 collapse ${bocetoDesplegado ? "show" : ""}`}>
              {prendaSeleccionada && (
                <>
                  {sketch && sketch.filename ? (
                    <div>
                      <div className="text-center">
                        <img
                          className={prendasModule.imagenboceto}
                          src={resolveFileUrl(sketch.filename)}
                          alt="Boceto"
                        />
                      </div>
                      {bocetoDesplegado && (
                        <div className={prendasModule.buttonsContainerB}>
                          {contextData.customer.customer_type === 3 ||
                          contextData.customer.customer_type === 2 ? (
                            <>
                              <a
                                href={downloadUrl}
                                download={`${prendaSeleccionada.product_name}_Boceto.png`}
                                target="_blank"
                                rel="noreferrer"
                                className={prendasModule.buttonOne}
                              >
                                DESCARGAR BOCETO
                              </a>
                              {sketch.uploaded_by_type !== "App\\Models\\User" ? (
                                // Es el DISEÑO del propio cliente (guía), todavía no el boceto final
                                // de la empresa: no se aprueba/rechaza, se muestra "en revisión".
                                <span
                                  style={{
                                    display: "inline-block",
                                    padding: "8px 14px",
                                    borderRadius: 999,
                                    background: "#fff7ed",
                                    color: "#9a3412",
                                    border: "1px solid #fed7aa",
                                    fontWeight: 700,
                                    fontSize: 13,
                                  }}
                                >
                                  🕒 En revisión — estamos armando tu diseño final
                                </span>
                              ) : sketch.approved_at === null ? (
                                <>
                                  <button
                                    className={prendasModule.buttonTwo}
                                    onClick={() => toggleModalA(sketch.id)}
                                  >
                                    APROBAR
                                  </button>
                                  <button
                                    className={prendasModule.buttonThree}
                                    onClick={toggleModal}
                                  >
                                    RECHAZAR
                                  </button>
                                </>
                              ) : (
                                <button
                                  className={prendasModule.buttonTwo}
                                  disabled
                                >
                                  BOCETO APROBADO
                                </button>
                              )}
                            </>
                          ) : (
                            <a
                              href={downloadUrl}
                              download={`${prendaSeleccionada.product_name}_Boceto.png`}
                              target="_blank"
                              rel="noreferrer"
                              className={prendasModule.buttonOne}
                            >
                              DESCARGAR BOCETO
                            </a>
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      <div className={prendasModule.noBoceto}>
                        <p>
                          ¿QUERÍAS UN BOCETO? <br />
                          NO HAY TAL BOCETO{" "}
                        </p>
                        <img src={fantasma} alt="fantasma" />
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
            {showModal && <BocetoModal onClose={toggleModal} boceto={sketch} />}
            {showModalA && <AprobarModal onClose={closeModalA} />}
            {showModalCargarGuia && (
              <CargarGuia
                cerrarModalCargarGuia={cerrarModalCargarGuia}
                prendaSeleccionada={prendaSeleccionada}
                orderItemId={orderItemId}
              />
            )}
          </section>

          {/* Talles: movidos a la sección dedicada "Talles" (nav). En Prendas, el
              delegado/tutor queda enfocado en diseño (guía + boceto). Bloque oculto. */}
          {/* eslint-disable-next-line no-constant-condition */}
          {true ? null : (
            <div className={`mt-3 ${prendasModule.guiaContainer}`}>
              <button
                className={`btn ${prendasModule.guiaBoton}`}
                onClick={toggleTalleDesplegado}
              >
                <span className={prendasModule.sectionHeaderMain}>
                  <span className={prendasModule.sectionTitleIconWrap}>
                    <i className={`bi bi-rulers ${prendasModule.sectionTitleIconMain}`} aria-hidden="true"></i>
                  </span>
                  <span className={prendasModule.sectionTitleTextWrap}>
                    <span className={prendasModule.sectionTitleText}>Talles</span>
                    <span className={prendasModule.sectionTitleUnderline} aria-hidden="true"></span>
                  </span>
                </span>
                {talleDesplegado ? (
                  <i className={`bi bi-caret-up-fill ${prendasModule.guiaToggleIcon}`}></i>
                ) : (
                  <i className={`bi bi-caret-down-fill ${prendasModule.guiaToggleIcon}`}></i>
                )}
              </button>
              <div className={`mt-2 collapse ${talleDesplegado ? "show" : ""}`}>
                <div className={prendasModule.sizeContainer}>
                  <p className={prendasModule.text}>
                    La cantidad total de prendas puede variar hasta que{" "}
                    <span className={prendasModule.strong}>
                      {" "}
                      el tutor confirma <br />y cierra el listado de talles.
                    </span>{" "}
                    <br />
                    Una vez hecho esto,
                    <span className={prendasModule.strong}>
                      {" "}
                      no se pueden realizar más cambios ni de apodo ni de
                      cantidades.
                    </span>
                  </p>
                  <div className={prendasModule.buttonsContainerT}>
                    {contextData.customer.customer_type !== 1 && (
                      <button
                        disabled={!botonHabilitado}
                        className={`${prendasModule.buttonThree} ${
                          !botonHabilitado && prendasModule.disabled
                        }`}
                        onClick={handleAlertconfirm}
                      >
                        CONFIRMAR TALLES
                      </button>
                    )}

                    <button
                      className={prendasModule.buttonTwo}
                      onClick={() => {
                        if (!prendaSeleccionada) {
                          Swal.fire({
                            icon: "warning",
                            iconColor: "#d54ab7",
                            confirmButtonColor: "#0071ce",
                            title: "Atención",
                            text: "Por favor, selecciona una prenda antes de continuar.",
                          });
                        } else {
                          toggleModalMediTuLittle();
                        }
                      }}
                    >
                      MEDÍ TU LITTLE
                    </button>

                    <button
                      disabled={!botonHabilitado}
                      className={`${prendasModule.buttonThree} ${
                        !botonHabilitado && prendasModule.disabled
                      }`}
                      onClick={() => {
                        if (!prendaSeleccionada) {
                          Swal.fire({
                            icon: "warning",
                            iconColor: "#d54ab7",
                            confirmButtonColor: "#0071ce",
                            title: "Atención",
                            text: "Por favor, seleccioná una prenda antes de continuar.",
                          });
                        } else if (
                          prendaSeleccionada &&
                          prendaSeleccionada.product_name.toLowerCase() ===
                            "bandera"
                        ) {
                          Swal.fire({
                            icon: "warning",
                            iconColor: "#d54ab7",
                            confirmButtonColor: "#0071ce",
                            title: "Atención",
                            text: "Bandera no posee talles.",
                          });
                        } else {
                          toggleCargarTalles();
                        }
                      }}
                    >
                      CARGAR TALLES
                    </button>
                  </div>
                </div>

                {showModalMediTuLittle && (
                  <MediTuLittleModal
                    prendaSeleccionada={prendaSeleccionada}
                    onClose={toggleModalMediTuLittle}
                    order_id={contextData.customer.order_id}
                  />
                )}

                {showModalCargarTalles && (
                  <CargarTalle
                    onClose={toggleCargarTalles}
                    orderItemId={orderItemId}
                    prenda={prendaSeleccionada.product_name}
                    prendasConPath={prendas}
                    moldingId={molding_itemCategory.current.moldingId}
                    orderItemCategoryId={molding_itemCategory.current.orderItemCategoryId}
                  />
                )}

                <summary
                  className={prendasModule.toggleContainer}
                  onClick={toggleOpen}
                >
                  <h5 className={prendasModule.talleCargado}>
                    {prendaSeleccionada !== null
                      ? prendaSeleccionada.alias !== null
                        ? ` TALLES CARGADOS PARA ${prendaSeleccionada.product_name.toUpperCase()} ${
                            prendaSeleccionada.alias
                          }`
                        : `TALLES CARGADOS PARA ${prendaSeleccionada.product_name.toUpperCase()}`
                      : "Seleccioná una prenda"}
                  </h5>
                  <img
                    src={Arrow}
                    alt=""
                    className={isOpen ? prendasModule.arrowRotate : ""}
                  />
                </summary>
                {isOpen && (
                  <>
                    <div className={prendasModule.titleTableContainer}>
                      <h6>
                        Vencimiento de requisitos: {requirementExpiration}
                      </h6>
                      <h6>Completado: {completedMessage}</h6>
                      <h6>Aprobado: {approvedMessage}</h6>
                      <SizeTable
                        paxes={paxes}
                        orderItemId={orderItemId}
                        onClose={toggleCargarTalles}
                        botonHabilitado={botonHabilitado}
                        moldingId={molding_itemCategory.current.moldingId}
                        orderItemCategoryId={molding_itemCategory.current.orderItemCategoryId}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
